import styled from "styled-components";

// tslint:disable-next-line
export const ManagerSearchResultClear = styled.a`
  position: relative;
  left: 260px;
  color: rgba(144, 187, 224, 1);
`;
